import {
    SHIP_PICKING_ROUTE,
    SHIP_PACKING_ROUTE,
    SHIP_PICK_ROUTE,
    SHIP_CANCEL_ROUTE,
    SHIP_DETAILS_ROUTE,
    SHIP_TITLE_PREFIX
} from '../../../modules/fulfillment/consts';

import { SHIPMENT_DETAILS_ROUTE } from '../../../modules/shipment/consts';
import { ORDERS_DETAILS_ROUTE } from '../../../modules/orders/consts';
import { PRODUCTS_DETAILS_ROUTE } from '../../../modules/products/consts';

export default {
    name: 'shipFulfillmentPickingPage',
    before: [],
    after: [],
    setup: (app) => {
        const routeName = 'fulfillmentShipPicking';
        const route = app.routes.getItem(routeName);

        if (route) {
            const routeProps = route.props;

            route.props = (state) => {
                return {
                ...routeProps(state),
                correctOrderRequired: false,
                withLocationStep: false,
                // to validate when new core release will be updated
                routes: {
                    orderDetailsPageRoute: ORDERS_DETAILS_ROUTE,
                    pickingPageRoute: SHIP_PICKING_ROUTE,
                    packingPageRoute: SHIP_PACKING_ROUTE,
                    pickPageRoute: SHIP_PICK_ROUTE,
                    cancelPageRoute: SHIP_CANCEL_ROUTE,
                    productDetailsPageRoute: PRODUCTS_DETAILS_ROUTE,
                    detailsPageRoute: SHIP_DETAILS_ROUTE,
                    shipmentDetailsPageRoute: SHIPMENT_DETAILS_ROUTE,
                    itemsPrintPageRoute: `/fulfillment-ship/print-items`,
                },
                permissions: {
                    canCancel: true,
                    canAssignUser: true,
                    canUnassignUser: true,
                    canPrintItems: true,
                    withProductDetailsLink: true,
                    withOrderDetailsLink: true,
                },
            }};

            app.routes.changeItem(routeName, route);


            app.routes.addItem('fulfillmentShipPrintItems', {
                path: `/fulfillment-ship/print-items/:id`,
                title: `${SHIP_TITLE_PREFIX} > Print Items`,
                permission: ['fulfillments.show'],
                breadcrumbConfig: { title: ' ', isReplaceble: true },
                props: () => ({}),
                loader: () => import('@skunexus/fulfillment-print-items'),
            });
        }
    },
};
